const map = {
	"./about-g1.jpg": 32446,
	"./about-g2.jpg": 12041,
	"./about-g3.jpg": 40428,
	"./about-g4.jpg": 46743,
	"./arrow_left.svg": 58148,
	"./arrow_right.svg": 44427,
	"./bilibili.svg": 39973,
	"./book-shadow-left.png": 2992,
	"./book-shadow-right.png": 38853,
	"./building.jpg": 70938,
	"./china_map.jpg": 52482,
	"./consluting.jpg": 63252,
	"./contact.jpg": 40464,
	"./contact.webp": 24169,
	"./culture_1.png": 76382,
	"./culture_2.png": 43733,
	"./culture_3.png": 74636,
	"./culture_4.png": 4803,
	"./culture_5.png": 87226,
	"./default_avatar.jpg": 77643,
	"./grid-1-1.jpg": 28118,
	"./grid-1-1.webp": 579,
	"./grid-1-2.jpg": 17697,
	"./grid-1-2.webp": 258,
	"./grid-1-3.jpg": 39652,
	"./grid-1-3.webp": 25197,
	"./grid-2-1.jpg": 99929,
	"./grid-2-1.webp": 41466,
	"./grid-2-3.jpg": 53899,
	"./grid-2-3.webp": 78168,
	"./grid-2-4.jpg": 47416,
	"./grid-2-4.webp": 33713,
	"./interior.jpg": 5374,
	"./interior.webp": 96395,
	"./landscape.jpg": 14875,
	"./logo.svg": 51792,
	"./map-mobile.jpg": 56871,
	"./no-data.png": 76950,
	"./people-banner-1.jpg": 3154,
	"./people-banner-2.jpg": 13053,
	"./planning.jpg": 79397,
	"./residential-1.jpg": 83748,
	"./residential-2.jpg": 9971,
	"./residential-3.jpg": 65206,
	"./shipinhao-qr.jpg": 45649,
	"./shipinhao.svg": 39150,
	"./sustainable.jpg": 92827,
	"./tianhua2019-bill.png": 73910,
	"./tianhua2020-banner.png": 51775,
	"./tianhua2020-bill.png": 73718,
	"./tianhua2020-notify.png": 10474,
	"./vetting.jpg": 22509,
	"./vrtech-1.jpg": 12880,
	"./vrtech-2.jpg": 96607,
	"./vrtech-3.jpg": 4898,
	"./vrtech-4.jpg": 90129,
	"./vrtech-5.jpg": 1972,
	"./vrtech-6.jpg": 48035,
	"./wechat-qr.jpg": 68438,
	"./wechat.svg": 11555,
	"./weibo.svg": 28607,
	"./xiaohongshu-qr.jpg": 75619,
	"./xiaohongshu.svg": 79804,
	"./zhihu.svg": 85185,
	"images/about-g1.jpg": 32446,
	"images/about-g2.jpg": 12041,
	"images/about-g3.jpg": 40428,
	"images/about-g4.jpg": 46743,
	"images/arrow_left.svg": 58148,
	"images/arrow_right.svg": 44427,
	"images/bilibili.svg": 39973,
	"images/book-shadow-left.png": 2992,
	"images/book-shadow-right.png": 38853,
	"images/building.jpg": 70938,
	"images/china_map.jpg": 52482,
	"images/consluting.jpg": 63252,
	"images/contact.jpg": 40464,
	"images/contact.webp": 24169,
	"images/culture_1.png": 76382,
	"images/culture_2.png": 43733,
	"images/culture_3.png": 74636,
	"images/culture_4.png": 4803,
	"images/culture_5.png": 87226,
	"images/default_avatar.jpg": 77643,
	"images/grid-1-1.jpg": 28118,
	"images/grid-1-1.webp": 579,
	"images/grid-1-2.jpg": 17697,
	"images/grid-1-2.webp": 258,
	"images/grid-1-3.jpg": 39652,
	"images/grid-1-3.webp": 25197,
	"images/grid-2-1.jpg": 99929,
	"images/grid-2-1.webp": 41466,
	"images/grid-2-3.jpg": 53899,
	"images/grid-2-3.webp": 78168,
	"images/grid-2-4.jpg": 47416,
	"images/grid-2-4.webp": 33713,
	"images/interior.jpg": 5374,
	"images/interior.webp": 96395,
	"images/landscape.jpg": 14875,
	"images/logo.svg": 51792,
	"images/map-mobile.jpg": 56871,
	"images/no-data.png": 76950,
	"images/people-banner-1.jpg": 3154,
	"images/people-banner-2.jpg": 13053,
	"images/planning.jpg": 79397,
	"images/residential-1.jpg": 83748,
	"images/residential-2.jpg": 9971,
	"images/residential-3.jpg": 65206,
	"images/shipinhao-qr.jpg": 45649,
	"images/shipinhao.svg": 39150,
	"images/sustainable.jpg": 92827,
	"images/tianhua2019-bill.png": 73910,
	"images/tianhua2020-banner.png": 51775,
	"images/tianhua2020-bill.png": 73718,
	"images/tianhua2020-notify.png": 10474,
	"images/vetting.jpg": 22509,
	"images/vrtech-1.jpg": 12880,
	"images/vrtech-2.jpg": 96607,
	"images/vrtech-3.jpg": 4898,
	"images/vrtech-4.jpg": 90129,
	"images/vrtech-5.jpg": 1972,
	"images/vrtech-6.jpg": 48035,
	"images/wechat-qr.jpg": 68438,
	"images/wechat.svg": 11555,
	"images/weibo.svg": 28607,
	"images/xiaohongshu-qr.jpg": 75619,
	"images/xiaohongshu.svg": 79804,
	"images/zhihu.svg": 85185
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89828;